import React, { useEffect } from 'react';
import { Box, Button, IconButton, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MobileDocumentsFileViewer from './Components/MobileDocumentsFileViewer';
import { BozpDocumentNewsResponseDTO, BozpDocumentNewsType } from '../../../ApiOld/ApiServerVov';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { ArrowBackIosNew } from '@mui/icons-material';

interface MobileDocumentFileDetailProps {
    item: BozpDocumentNewsResponseDTO;
    onSignClick: () => void;
    onRejectClick: () => void;
    onClose: () => void;
}

const MobileDocumentFileDetail: React.FC<MobileDocumentFileDetailProps> = ({ item, onSignClick, onRejectClick, onClose }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { setModuleButton, setModuleName, setModuleSecondButton } = useEmployeeContext();

    useEffect(() => {
        if (item.type === BozpDocumentNewsType.News) {
            console.log('bozp', item);
        }
    }, [item]);

    useEffect(() => {
        setModuleButton && setModuleButton(
            <IconButton onClick={() => {
                onClose();
            }}>
                <ArrowBackIosNew />
            </IconButton>
        );
        setModuleSecondButton && setModuleSecondButton(null);
    }, [setModuleButton, setModuleName, t, setModuleSecondButton]);

    const supportedFileTypes = ['pdf', 'jpg', 'jpeg', 'png'];
    const fileExtension = item.file?.split('.').pop()?.toLowerCase() ?? "";

    return (
        <Box className="mobile-document-detail" alignItems={'center'} width={'100%'} height={'100%'} padding={1} bgcolor={theme.palette.background.paper} boxShadow={3} borderRadius={'10px'} >
            <MobileDocumentsFileViewer url={item.file} />
            {/* <Button size='small' onClick={onClick}>{t('read')}</Button> */}
            {(!item.isRead && !item.isRejected) && supportedFileTypes.includes(fileExtension) && <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                {item.type === BozpDocumentNewsType.Document && <Button size='small' onClick={() => onRejectClick()}>{t('reject')}</Button>}
                <Button size='small' onClick={() => onSignClick()}>{t('sign')}</Button>
            </Box>}
        </Box>
    );
};

export default MobileDocumentFileDetail;